import api from './api';

// Exceptions de planning : pour une date précise, elles remplacent le planning
// hebdomadaire (jour fermé, mode Salon/Domicile différent, autres horaires, autres villes).
// Toutes les dates échangées avec l'API sont des chaînes 'YYYY-MM-DD'.

// 📌 Public : planning exceptionnel d'une période (sans le motif, qui reste interne).
// Renvoie [{ date, actif, mode, plages: [{ heure_debut, heure_fin }], departements: [{ code_postal, nom }] }]
export const getExceptionsPubliques = async (debut, fin) => {
  try {
    const response = await api.get('/planning-exception/periode', { params: { debut, fin } });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des exceptions de planning", error);
    return [];
  }
};

// 📌 Admin : exceptions d'une période, avec leur motif.
// Contrairement à la version publique, une erreur est remontée : l'écran admin ne doit
// pas afficher « planning normal » simplement parce que l'appel a échoué.
export const getExceptionsAdmin = async (debut, fin) => {
  const response = await api.get('/planning-exception', { params: { debut, fin } });
  return response.data;
};

// 📌 Admin : crée ou remplace entièrement l'exception d'une date.
// payload = { actif, mode, motif, plages: [{ heure_debut, heure_fin }], departements: [{ code_postal, nom }] }
export const enregistrerException = async (date, payload) => {
  const response = await api.put(`/planning-exception/${date}/complet`, payload);
  return response.data;
};

// 📌 Admin : supprime l'exception d'une date (le jour revient au planning normal).
export const supprimerException = async (date) => {
  const response = await api.delete(`/planning-exception/${date}`);
  return response.data;
};
